import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);

        // Set initial value
        setMatches(mediaQuery.matches);

        // Create event listener function
        const handler = (event) => setMatches(event.matches);

        // Add event listener
        mediaQuery.addEventListener('change', handler);

        // Clean up
        return () => mediaQuery.removeEventListener('change', handler);
    }, [query]); // Re-run effect if query changes

    return matches;
};

export default useMediaQuery;

// const isMobile = useMediaQuery('(max-width: 768px)');
// const isDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
